import { graphql } from 'src/gql'
import { StaffingAgencyPocByIdQueryVariables } from 'src/gql/graphql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL, UseGraphqlOptions } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query staffingAgencyPocById($id: MongoID!) {
    cat {
      staffingAgencyPoc {
        byId(_id: $id) {
          _id
          name
          title
          email
          phone
          type
          address {
            street
            city
            state
            zip
          }
          timezone
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type StaffingAgencyPocById = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['staffingAgencyPoc']>['byId']>

const useStaffingAgencyPocById = (id: string, variables?: StaffingAgencyPocByIdQueryVariables, options?: UseGraphqlOptions<TData>, enabled: boolean = true): StaffingAgencyPocById | undefined => {
  const internalVariables: StaffingAgencyPocByIdQueryVariables = Object.assign({
    id
  }, variables)
  const { data } = useGraphQL(document, internalVariables, options)
  return data?.cat?.staffingAgencyPoc?.byId ?? undefined
}

export { useStaffingAgencyPocById, document as staffingAgencyPocByIdDocument }
